exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-selector{padding:0 1.75em}.course-selector .search-container{margin-bottom:.55rem}.course-selector .tabs .selector{margin-bottom:0}.course-selector .course{cursor:pointer;padding:1.1rem 1.75em;margin-left:-1.25rem;margin-right:-1.25rem}.course-selector .course:hover{background-color:#f5f5f5}.course-selector .course .dots-container{display:flex;align-items:center}.course-selector .course .check{margin-right:1.25rem}", ""]);

// exports
